/*
 * Registers the Uptime page and its sidebar link.
 *
 * Unlike the evidence products (Discovery, Blueprint, …), this page presents nothing of our own:
 * it passes through Uptime Kuma's read-only STATUS PAGE in a frame, so the estate's continuous
 * availability is visible inside the app rather than only over an SSH tunnel
 * ([ADR 0027](../../../docs/decisions/0027-embed-a-read-only-kuma-status-page.md)). It is an
 * operational surface, not an evidence product, so it ships its own `NavItem` alongside Agents /
 * Backups rather than joining the product cluster in `products.ts`.
 *
 * Same shape as every other overlay page: `PageBlueprint`, `pluginId: 'app'`, and
 * `oss_apps/backstage` untouched.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export const UPTIME_PATH = '/uptime';

const uptimePage = PageBlueprint.make({
  name: 'stackschematic-uptime',
  params: {
    path: UPTIME_PATH,
    loader: async () => {
      const { UptimePage } = await import('./UptimePage');
      return <UptimePage />;
    },
  },
});

export const stackSchematicUptimeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [uptimePage],
});
